import { apiFetch } from '@ami/react/core';
import { AnnouncementFilter } from './announcementFilter';
import moment from 'moment';

const _baseEndPoint = 'announcements';

export const announcementTypes = Object.freeze({
  alert: 'Alert',
  card: 'Card',
});

export class Announcement {
  constructor(item) {
    if (item) {
      this.id = item.id;
      this.name = item.name;
      this.description = item.description;
      this.priceZoneIds = item.priceZoneIds;
      this.dealerGroupIds = item.dealerGroupIds;
      this.preferredMakeIds = item.preferredMakeIds;
      if (item.startDate) {
        this.startDate = moment(item.startDate);
      }
      if (item.endDate) {
        this.endDate = moment(item.endDate);
      }
      this.imageKey = item.imageKey;
      this.imageUrl = item.imageUrl;
      this.type = item.type;
      this.sortOrder = item.sortOrder;
      this.linkUrl = item.linkUrl;
      return;
    }
    this.id = null;
    this.name = '';
    this.description = '';
    this.startDate = null;
    this.endDate = null;
    this.priceZoneIds = [];
    this.dealerGroupIds = [];
    this.preferredMakeIds = [];
    this.imageKey = null;
    this.imageUrl = null;
    this.type = null;
    this.sortOrder = '';
    this.linkUrl = '';
  }

  static async search(filter = new AnnouncementFilter(), page) {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result.map((x) => new Announcement(x));
  }

  static async getById(id) {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new Announcement(entity);
  }

  static create(item) {
    return apiFetch(_baseEndPoint, 'POST', item);
  }

  update() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'PUT', this);
  }

  delete() {
    return apiFetch(`${_baseEndPoint}/${this.id}`, 'DELETE', this);
  }
}
